// import { GenerateXMLButton } from "components/GenerateXMLButton";

import { AppBar, Box, Toolbar, useTheme } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	RHookFormTextField,
	SplitButton,
	SubmitButton,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { IAppState } from "../../../store/reducers";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import PrintIcon from "@mui/icons-material/Print";
import { useSelector } from "react-redux";

export interface IRL1SummaryToolbar {
	// onGenerateXMLClicked: () => void;
	onPrintClicked: (selectedItem: string, index: number) => void;
	onDeleteClicked: () => void;
	isSubmitting: boolean;
	pageTitle: string;
}

export const RL1SummaryToolbar: FC<IRL1SummaryToolbar> = ({
	// onGenerateXMLClicked,
	onPrintClicked,
	onDeleteClicked,
	isSubmitting = false,
	pageTitle,
}) => {
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const [subMenuVisibilityState, setSubMenuVisibility] =
		useState(subMenuVisibility);
	useEffect(() => {
		if (subMenuVisibility) {
			setSubMenuVisibility(subMenuVisibility);
		}
	}, [subMenuVisibility]);
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			sx={{
				backgroundColor: "#F7F7F7",
				paddingBottom: "16px",
				boxShadow: "none",
				zIndex: theme.zIndex.appBar + 1,
				position: "sticky",
				top: subMenuVisibility ? "112px" : "64px",
				// top: "112px",
			}}
		>
			<Toolbar
				sx={{
					paddingTop: { sm: 1.75, md: 1.75, lg: 1.75, xl: 1.75 },
					paddingBottom: { sm: 0, md: 0, lg: 0, xl: 0 },
					paddingLeft: { sm: 0, md: 0, lg: 0, xl: 0 },
					paddingRight: { sm: 0, md: 0, lg: 0, xl: 0 },
					minHeight: { sm: "48px", md: "48px", lg: "48px", xl: "48px" },
					fontWeight: "700",
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
					{pageTitle}
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<div
						// style={{ display: "flex", width: "50%", alignItems: "center" }}
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<div
							style={{
								alignSelf: "center",
								paddingTop: "3px",
								paddingRight: "12px",
							}}
						>
							<EnhancedButtonPrimeReact
								label="Submit"
								loading={isSubmitting}
								type="submit"
								raised
								severity={EnhancedButtonPrimeReactSeverity.Success}
							/>
						</div>
						<Box
							sx={{
								"& .MuiTextField-root": {
									marginBottom: "0!important",
									marginTop: "2px!important",
								},
								"& .MuiTextField-root input": {
									padding: "7.2px 14px!important",
								},
							}}
						>
							<RHookFormTextField
								id="confirmationCode"
								testId={"confirmation-number"}
								placeholder="Confirmation Number"
							/>
						</Box>
						{isAdminUser === 400 ? (
							<Box sx={{ display: "flex", alignItems: "center" }}>
								<EnhancedButtonPrimeReact
									label="Delete"
									raised
									onClickHandler={onDeleteClicked}
									style={{ marginLeft: "1rem" }}
									severity={EnhancedButtonPrimeReactSeverity.Danger}
								/>
							</Box>
						) : (
							<></>
						)}
					</div>
					{/* <div style={{ flexGrow: 1 }} /> */}
					{/* <div style={{ marginLeft: theme.spacing(2), 
					"& .MuiBox-root " :{
										background: theme.palette.primary.main
									}, }}
					
					>
						<SplitButton
							options={["Print PDF (English)", "Print PDF (French)"]}
							onClickHandler={onPrintClicked}
							testId="t4-print-button"
							icon={<PrintIcon />}
							listItemsLabel={`Print Summary  `}
						/>
					</div> */}

					<Box sx={{
						marginLeft: theme.spacing(2),
						"& .MuiBox-root": {
							background: theme.palette.primary.main
						}
					}}>
						<SplitButton
							options={["Print PDF (English)", "Print PDF (French)"]}
							onClickHandler={onPrintClicked}
							testId="t4-print-button"
							icon={<PrintIcon />}
							listItemsLabel={`Print Summary  `}
						/>
					</Box>
				</div>
			</Toolbar>
		</AppBar>
	);
};
